import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Profile = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <path
        stroke="#3A3A3A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M11.845 21.661C8.153 21.661 5 21.087 5 18.786c0-2.3 3.133-4.425 6.845-4.425 3.691 0 6.844 2.104 6.844 4.404s-3.133 2.896-6.844 2.896M11.838 11.174a4.386 4.386 0 1 0 0-8.774A4.39 4.39 0 0 0 7.45 6.788a4.37 4.37 0 0 0 4.357 4.386z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default Profile;
